// extracted by mini-css-extract-plugin
module.exports = {"root":"ProjectList_root__AHUt4","listItemLight":"ProjectList_listItemLight__2Ljrm","listItemDark":"ProjectList_listItemDark__17PQU"};